import React, { useState, useEffect, useLayoutEffect } from 'react';

import CentredHeader from '../../generals-components/headers/centred-header';
import SubscriptionPageMain from './components/main';
import Footer from '../../generals-components/footer/footer';

async function checkUserSession() {
    const response = await fetch('/api/check-token', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

async function getUserSubscription() {
    const response = await fetch('/api/get-account-subscription', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const subscription = await response.json();
        return subscription;
    } else {
        return false;
    }
}

async function getUserData() {
    const response = await fetch('/api/get-account-data', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const user_data = await response.json();
        return user_data;
    } else {
        return false;
    }
}

function SubscriptionPage() {
    const [userSubscription, setUserSubscription] = useState("free")
    const [isUserLogged, setIsUserLogged] = useState(false)

    useEffect(() => {
        async function fetchData() {
            if (await checkUserSession()) {
                setUserSubscription(await getUserSubscription());
            }
        }
        fetchData()
    }, []);

    useLayoutEffect(() => {
        async function checkIfUserIsLogged() {
            setIsUserLogged(await checkUserSession())
        }

        checkIfUserIsLogged()
    }, [])

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='bg-background-light dark:bg-background-dark font-display text-slate-900 dark:text-white min-h-screen selection:bg-primary selection:text-white'>
            <CentredHeader isUserLogged={isUserLogged} setIsUserLogged={setIsUserLogged} currentPage={"Pricing"}/>

            <SubscriptionPageMain/>

            <Footer currentPage={"Pricing Plans"}/>
        </div>
    );
}

export default SubscriptionPage;